module.exports = __webpack_public_path__ + "img/Interface tool.2ee5df5d.svg";